// Dependency
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

// Context
import CartProvider from "../contexts/cart-context";
import ContentFlyinContext from "./modals/modal-flyin/ContentFlyinContext";
import NotificationContext from "./errors/notification-context";

// Styles
import '../styles/index.scss';

// Components
import Header from "./header/header"
import Footer from "./footer/footer";
import MiniCart from "./mini-cart/mini-cart";
import Head from "./head";
import ModalFlyIn from "./modals/modal-flyin/modal-flyin";
import ContentFlyIn from "./modals/modal-flyin/content-flyin";
import Error from "./errors/error";
import QuickCart from "./mini-cart/quick-cart";

// Template
const Layout = (props) => {
    const [flyinOpen, setFlyinOpen] = useState(false);
    const toggleFlyIn = () => {
        setFlyinOpen(!flyinOpen);
    }
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    }
    const [contentModalOpen, setContentModalOpen] = useState(false);
    const toggleContentModal = () => {
        setContentModalOpen(!contentModalOpen);
    }
    const [contentModalContent, setContentModalContent] = useState('');

    // State for notifications
    const [notificationOpen, setNotificationOpen] = useState({
        type: '',
        copy: {
            title: '',
            text: ''
        }
    });

    // Toggle notification with desired delay
    const toggleNotifications = (data, delay = 0) => {
        setNotificationOpen(data);
        setTimeout(() => {
            setNotificationOpen({
                type: '',
                copy: {
                    title: '',
                    text: ''
                }
            });
        }, delay);
    };

    //PartnerAds Cookie
    useEffect(() => {
        //GET URL params
        const urlParams = new URLSearchParams(window.location.search);
        const paid = urlParams.get('paid');
        const pacid = urlParams.get('pacid');

        //If URL PArams match
        if (paid && pacid) {
            Cookies.set('_partnerads', `${paid}|${pacid}`, { expires: 40 });
        }
        //Check if cookie is set? update?
        //Otherwise set cookie
        //const co = Cookies.get('partnerads');

    }, []);

    return (
        <CartProvider currentCountry={props.country} location={props.location}>
            <Head data={props.seoData} country={props.country} location={props.location} />
            <Header
                flyinToggle={toggleFlyIn}
                mobileMenuToggle={toggleMobileMenu}
                isCheckout={props.isCheckout}
                isSwedenHeader={props.isSwedenHeader}
                country={props.country}
                dropDownOpened={props.dropDownOpened}
                isAbsolute={props.isAbsolute}
                isHome={props.isHome}
            />
            <ContentFlyinContext.Provider value={{ toggleContentModal, setContentModalContent }}>
                <NotificationContext.Provider value={{ toggleNotifications }}>
                    {props.children}
                </NotificationContext.Provider>
            </ContentFlyinContext.Provider>
            <Footer
                flyinToggle={toggleFlyIn}
                country={props.country}
                isHome={props.isHome}
            />
            <MiniCart country={props.country} />
            <QuickCart country={props.country} />
            <ModalFlyIn country={props.country} direction={'right'} isOpen={flyinOpen} flyinToggle={toggleFlyIn} />
            <ContentFlyIn
                direction={'right'}
                isOpen={contentModalOpen}
                flyinToggle={toggleContentModal}
                content={contentModalContent}
            />
            <Error
                type={notificationOpen.type}
                data={notificationOpen.copy}
                toggleNotification={setNotificationOpen}
            />
        </CartProvider>
    );
}
export default Layout;